import { SHStackProps, SHTypography } from "@components/design-systems";
import React from "react";
import { useTheme } from "@mui/material";

type MSFilterItemLabelProps = SHStackProps & {
  size?: "small" | "medium";
  disabled?: boolean;
};

export const MSFilterItemLabel = ({
  size,
  disabled = false,
  ...others
}: MSFilterItemLabelProps) => {
  const { palette } = useTheme();
  const isSmallSize = size === "small";

  return (
    <SHTypography
      fontSize={isSmallSize ? 11 : 13}
      fontWeight={600}
      color={disabled ? palette.action.disabled : palette.text.primary}
    >
      {others.children}
    </SHTypography>
  );
};
